import React from 'react'
import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'

const HireFilter = ({ setHire, value }) => {
  const options = [
    {
      label: '0-10',
      value: '0-10',
    },
    {
      label: '10-100',
      value: '10-100',
    },
    {
      label: '100-500',
      value: '100-500',
    },
    {
      label: '500-1000',
      value: '500-1000',
    },
  ]

  const onChange = checkedValues => {
    setHire(checkedValues)
  }
  return (
    <FilterCheckBoxComp options={options} value={value} onChange={onChange} multiple />
  )
}

export default HireFilter
